// extracted by mini-css-extract-plugin
export default {"title":"HgPg6d","subtitle":"IRmuZ8"};